const URL = "https://moaserver.dplanit.co.kr/";
// const URL = "http://localhost:8081";


export { URL };
